/* **The one-of-N picker** — `PickerList`'s search box, live count, reserve and retry.
 *
 * Moved unchanged out of `features/assign-plan/ui/AssignPlanDialog.module.css` on 25 September 2026
 * with the component itself, on its second consumer (the booking calendar's "Nowa sesja"). The rows
 * inside the reserve are `choiceRow.module.css`'s.
 *
 * Every colour, space, radius and type value is a token; heights are layout. */

.search {
  box-sizing: border-box;
  width: 100%;
  height: var(--h-ex-wizard-row);
  padding: var(--space-0) var(--space-3);
  font: inherit;
  font-size: var(--fs-label-md);
  color: var(--text);
  background: var(--bg-inset);
  border: var(--border-hairline) solid var(--border-2);
  border-radius: var(--radius-sm);
}

.search::placeholder {
  color: var(--text-3);
}

.count {
  margin: var(--space-0);
  font-size: var(--fs-micro);
  color: var(--text-2);
}

/* The reserve. It holds this height in all four of its states, so the answer landing changes ink
 * and never geometry — and the skeleton inside it fits, which is what stops the box shrinking when
 * the read lands. */
.pickerBox {
  display: flex;
  flex-direction: column;

  /* A surface may shorten the reserve through `--picker-height` — never by redeclaring it. */
  height: var(--picker-height, var(--h-assign-picker));
  overflow-y: auto;
}

.pickerBar {
  flex: none;
  height: var(--space-10);
  margin-bottom: var(--space-2px);
}

.retry {
  align-self: flex-start;
  padding: var(--space-2) var(--space-3);
  font: inherit;
  font-size: var(--fs-label-md);
  font-weight: var(--fw-bold);
  color: var(--text);
  background: var(--bg-inset);
  border: var(--border-hairline) solid var(--border-2);
  border-radius: var(--radius-sm);
  cursor: pointer;
}
